<template>
  <div class="moderation-summary__comments">
    <div v-if="data !== null && !moderationDisabled" class="comment">
      <label for="add-comment">Bieżący komentarz:</label>
      <BaseTextarea id="add-comment" v-model="data.comment" />
    </div>
    <div v-if="previousComments.length > 0">
      <div
        v-for="(comment, idx) in previousComments"
        :key="idx"
        class="comment"
      >
        <p class="comment__meta">
          <span class="comment__user">{{ comment.user }}</span>
          <span class="comment__date">{{ comment.date }}</span>
        </p>
        <p class="comment__message" v-html="comment.comment"></p>
        <!-- <a
          v-if="!moderationDisabled"
          href="#"
          class="comment__message-reuse"
          @click.prevent="useComment(idx)"
          >(Ponownie użyj tego komentarza)</a
        > -->
      </div>
    </div>
    <div v-else>Brak</div>
  </div>
</template>

<script>
import BaseTextarea from "../Controls/BaseTextarea";
import { mapState } from "vuex";

export default {
  name: "BaseAdminCertificationSummaryComment",
  components: {
    BaseTextarea
  },
  props: {
    value: {
      required: true
    },
    comments: {
      type: Array,
      requried: true,
      default: () => []
    }
  },
  data() {
    return {
      data: this.value
    };
  },
  computed: {
    ...mapState("Form", ["formDisabled"]),
    ...mapState("Event", ["moderationDisabled"]),
    filteredComments() {
      return this.data
        ? this.comments.filter(item => item.type !== "current")
        : this.comments;
    },
    previousComments() {
      let comments = [];
      if (this.moderationDisabled) {
        comments = this.comments.filter(item => item.comment);
      } else {
        comments = this.comments.filter(
          item => item.type !== "current" && item.comment
        );
      }
      return comments;
    }
  },
  watch: {
    "value.comment": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.data.comment = newValue;
      }
    },
    "data.comment": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$emit("input", newValue);
      }
    }
  },
  methods: {
    useComment(idx) {
      this.$set(this.data, "comment", this.comments[idx].comment);
    }
  }
};
</script>
